<mat-card class="cardWithShadow theme-card">
  <mat-card-header>
    <mat-card-title class="m-b-0">Progress Spinner</mat-card-title>
  </mat-card-header>
  <mat-card-content class="b-t-1">
    <mat-card class="b-1 shadow-none">
      <mat-card-header>
        <mat-card-title>Basic</mat-card-title>
      </mat-card-header>
      <mat-card-content class="b-t-1">
        <mat-spinner></mat-spinner>
      </mat-card-content>
    </mat-card>

    <mat-card class="b-1 shadow-none">
      <mat-card-header>
        <mat-card-title>Configurable </mat-card-title>
      </mat-card-header>
      <mat-card-content class="b-t-1">
        <div>
          <label class="mat-body-2 f-w-600">Color:</label>
          <mat-radio-group [(ngModel)]="color">
            <mat-radio-button class="example-margin" value="primary">
              Primary
            </mat-radio-button>
            <mat-radio-button class="example-margin" value="accent">
              Accent
            </mat-radio-button>
            <mat-radio-button class="example-margin" value="warn">
              Warn
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div>
          <label class="mat-body-2 f-w-600">Mode:</label>
          <mat-radio-group [(ngModel)]="mode">
            <mat-radio-button class="example-margin" value="determinate" color="primary">
              Determinate
            </mat-radio-button>
            <mat-radio-button class="example-margin" value="indeterminate" color="primary">
              Indeterminate
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div *ngIf="mode === 'determinate'">
          <label class="mat-body-2 f-w-600">Progress:</label>
          <mat-slider class="example-margin">
            <input type="range" [(ngModel)]="value" matSliderThumb />
          </mat-slider>
        </div>

        <div class="p-24 rounded bg-light-primary m-t-16">
          <h2 class="mat-body-2 f-w-600 m-b-16">Result</h2>

          <mat-progress-spinner
            class="example-margin"
            [color]="color"
            [mode]="mode"
            [value]="value"
          >
          </mat-progress-spinner>
        </div>
      </mat-card-content>
    </mat-card>
  </mat-card-content>
</mat-card>
